import React from "react";
import { FormGroup, Label, Input } from "reactstrap";

const StepPrimeOptions = ({ myInitInfo, setMyInitInfo, primeLevelCodes, primeWeekCodes }) => {
    return (
        <FormGroup className="prime">
            <Label className="conlabel">
                3. 레벨과 요일을 선택해주세요. <span>(프라임 시간표 전용)</span>
            </Label>

            <div className="prime-option">
                <p className="prime-subtitle">레벨</p>
                {primeLevelCodes.map((info, idx) => (
                    <FormGroup key={idx} check className="d_inb">
                        <Input
                            type="radio"
                            name="radio-prime-level"
                            id={"prime-level" + idx}
                            value={info.VALUE}
                            checked={myInitInfo.primeLevel === info.VALUE}
                            onChange={(e) => {
                                setMyInitInfo({
                                    ...myInitInfo,
                                    primeLevel: e.target.value,
                                });
                            }}
                        />
                        <Label check htmlFor={"prime-level" + idx}>
                            <span className="icon" />
                            {info.NAME === "표준" ? "기본" : info.NAME}
                        </Label>
                    </FormGroup>
                ))}
            </div>

            <div className="prime-option">
                <p className="prime-subtitle">요일</p>
                {/* 요일 디폴트: 영어_월수금 / 수학_화목금 */}
                {primeWeekCodes.map((info, idx) => (
                    <FormGroup key={idx} check className="d_inb">
                        <Input
                            type="radio"
                            name="radio-prime-week"
                            id={"prime-week" + idx}
                            value={info.VALUE}
                            checked={myInitInfo.primeWeek === info.VALUE}
                            onChange={(e) => {
                                setMyInitInfo({
                                    ...myInitInfo,
                                    primeWeek: parseInt(e.target.value),
                                });
                            }}
                        />
                        <Label check htmlFor={"prime-week" + idx}>
                            <span className="icon" />
                            {info.NAME}
                        </Label>
                    </FormGroup>
                ))}
            </div>
        </FormGroup>
    );
};
export default StepPrimeOptions;
